import PropTypes from 'prop-types';
import { Buttons } from 'lidya-common-components';
import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import { useModalData } from '../../common/providers/modalProvider/modalDataProvider.useModalData';

export const SignUpButton = ({ type, className, onClick, label, id }) => {
  const { toggleModal, forceShowModal, showModal } = useModalData();
  const { t } = useTranslation();
  const isShowingAlready = useRef(false);

  useEffect(() => {
    const openSignUp = sessionStorage.getItem('openSignUp') === 'true';
    const { current } = isShowingAlready;
    if (!current && !showModal && openSignUp) {
      isShowingAlready.current = true;
      setTimeout(() => {
        sessionStorage.removeItem('openSignUp');
      }, 100);
      forceShowModal();
    }
  }, [forceShowModal, showModal]);

  return (
    <Buttons.Button
      key={id}
      id={id}
      type={type}
      className={className}
      onClick={() => {
        onClick();
        toggleModal();
      }}
    >
      {t(label)}
    </Buttons.Button>
  );
};

SignUpButton.propTypes = {
  className: PropTypes.string,
  id: PropTypes.string.isRequired,
  label: PropTypes.string,
  onClick: PropTypes.func,
  type: PropTypes.string,
};

SignUpButton.defaultProps = {
  className: undefined,
  label: 'web.navigation.sign.up',
  onClick: () => {},
  type: Buttons.BUTTON_TYPES.PRIMARY,
};

export default SignUpButton;
